module.exports = __webpack_public_path__ + "static/OG_TeamAug-95ee79e2a6a3d2aadd9c5a8e102f31fb.jpg";